import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import moment from "moment";

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const TableComplaintsAndClaims = ({ title, reactTableData, ReactTableActions, Callback }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        manualPageSize: [5, 10, 15, 20],
        useActions: true,
        actions: (data) => ReactTableActions({ data, Callback })
    };

    const columnsData = [
        {
            Header: "Consecutivo",
            accessor: 'id_queja',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        /*{
            Header: "Canal de Recepcion",
            accessor: 'canal_recepcion',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },*/
        {
            Header: "Nombre del Paciente",
            accessor: 'nombre_paciente',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Fecha Radicado",
            accessor: 'fecha_radicado',
            Cell: row => (
                <label>
                    {row.value != null && row.value != undefined ? moment(row.value).format("DD/MM/YYYY") : ""}
                </label>
            )
        },
        {
            Header: "Asunto",
            accessor: 'queja_asunto_descripcion',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Causas",
            accessor: 'queja_reclamo',
            Cell: row => (
                <div style={{ maxHeight: '100px', maxWidth: '350px',width: '350px' , overflowY: 'scroll' }}>
                    <label>
                        {row.value}
                    </label>
                </div>
            )
        },
        /*{
            Header: "Fecha Respuesta",
            accessor: 'fecha_respuesta',
            Cell: row => (
                <label>
                    {row.value != undefined && row.value != null ? moment(row.value).format("DD/MM/YYYY") : ""}
                </label>
            )
        },
        {
            Header: "Respuesta al Requerimiento",
            accessor: 'respuesta_requerimiento',
            Cell: row => (
                <div style={{ maxHeight: '100px', overflowY: 'scroll' }}>
                    <label>
                        {row.value != undefined && row.value != null ? moment(row.value).format("DD/MM/YYYY") : ""}
                    </label>
                </div>
            )
        },*/
        {
            Header: "Medio",
            accessor: 'medio',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Prioridad",
            accessor: 'prioridad_nombre',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
        {
            Header: "Seguimiento",
            accessor: 'seguimiento_nombre',
            Cell: row => (
                <label>
                    {row.value}
                </label>
            )
        },
    ];

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

TableComplaintsAndClaims.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default TableComplaintsAndClaims;
